module.exports = __webpack_public_path__ + "img/andreea-social-proof-cta.082127eb.png";